import { render } from "./AccountLoader.vue?vue&type=template&id=3b2c7fa4&ts=true"
import script from "./AccountLoader.vue?vue&type=script&lang=ts"
export * from "./AccountLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__